import { supabase } from "./supabaseClient";

// Tags a scan's business (the database links the business when the scan is
// saved). New tags are made, existing ones reused whatever their capitals;
// safe to call again. Returns { tags } (all the business's tags), or { error }.
// A scan with no business (no website) can't be tagged.
export async function tagScanBusiness(jobId, tagNames) {
  const { data: job, error: readError } = await supabase.from("jobs").select("business_id").eq("id", jobId).maybeSingle();
  if (readError) return { error: readError.message };
  if (!job || !job.business_id) return { error: "This snapshot has no business to tag" };
  const { data, error } = await supabase.rpc("add_business_tags", { business: job.business_id, tag_names: tagNames });
  if (error) return { error: error.message };
  return { tags: data || [] };
}
